function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M43.8369 43.8369L55.3794 55.3794",
    stroke: "#00B3FF",
    style: {
      stroke: "#00B3FF",
      stroke: "color(display-p3 0.0000 0.7008 1.0000)",
      strokeOpacity: 1
    },
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4165 48.6667C40.4957 48.6667 48.6665 40.4959 48.6665 30.4167C48.6665 20.3376 40.4957 12.1667 30.4165 12.1667C20.3373 12.1667 12.1665 20.3376 12.1665 30.4167C12.1665 40.4959 20.3373 48.6667 30.4165 48.6667Z",
    stroke: "#00B3FF",
    style: {
      stroke: "#00B3FF",
      stroke: "color(display-p3 0.0000 0.7008 1.0000)",
      strokeOpacity: 1
    },
    strokeWidth: 5,
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch1);
export default __webpack_public_path__ + "static/media/search 1.4260784ff76a840506b0635a72f1aeca.svg";
export { ForwardRef as ReactComponent };